import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe85e66c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-white bg-black-black" }
const _hoisted_2 = { class: "p-2 flex items-center justify-between bg-black-body" }
const _hoisted_3 = { class: "m-0 inline-block" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("You are playing ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" in ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path4" }, null, -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "text-warning" }
const _hoisted_12 = { class: "flex flex-col lg:flex-row h-full w-full px-9 pb-14 space-y-9 lg:space-x-9" }
const _hoisted_13 = { class: "relative flex justify-center items-center lg:w-4/5" }
const _hoisted_14 = {
  key: 1,
  class: "cover-img p-0 m-2 block overflow-hidden"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "absolute flex flex-col space-y-3 w-1/2 sm:w-1/3 lg:w-1/4" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Play Game ")
const _hoisted_18 = { class: "flex flex-col lg:w-1/5" }
const _hoisted_19 = { class: "text-white text-3xl mb-2 font-bold" }
const _hoisted_20 = { class: "flex items-center space-x-1.5 mb-5" }
const _hoisted_21 = {
  key: 1,
  class: "flex align-baseline pt-1 text-xs"
}
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-xl font-bold mb-3" }, "Game Features"),
  /*#__PURE__*/_createElementVNode("ul", { class: "text-sm" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-2" }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "aria-hidden": "true",
          role: "img",
          class: "iconify iconify--charm h-4 w-4 text-red-primary",
          preserveAspectRatio: "xMidYMid meet",
          viewBox: "0 0 16 16"
        }, [
          /*#__PURE__*/_createElementVNode("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "m2.75 8.75l3.5 3.5l7-7.5"
          })
        ]),
        /*#__PURE__*/_createElementVNode("span", null, "Scary Bear with Cute Visuals ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-2" }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "aria-hidden": "true",
          role: "img",
          class: "iconify iconify--charm h-4 w-4 text-red-primary",
          preserveAspectRatio: "xMidYMid meet",
          viewBox: "0 0 16 16"
        }, [
          /*#__PURE__*/_createElementVNode("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "m2.75 8.75l3.5 3.5l7-7.5"
          })
        ]),
        /*#__PURE__*/_createElementVNode("span", null, "Endless Gameplay ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-2" }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "aria-hidden": "true",
          role: "img",
          class: "iconify iconify--charm h-4 w-4 text-red-primary",
          preserveAspectRatio: "xMidYMid meet",
          viewBox: "0 0 16 16"
        }, [
          /*#__PURE__*/_createElementVNode("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "m2.75 8.75l3.5 3.5l7-7.5"
          })
        ]),
        /*#__PURE__*/_createElementVNode("span", null, "Easy Controls ")
      ])
    ])
  ])
], -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" View More Game Details")
const _hoisted_25 = { class: "flex flex-col space-y-4 card-cover my-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--mdi",
  width: "32",
  height: "32",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M20.5 11H19V7a2 2 0 0 0-2-2h-4V3.5A2.5 2.5 0 0 0 10.5 1A2.5 2.5 0 0 0 8 3.5V5H4a2 2 0 0 0-2 2v3.8h1.5c1.5 0 2.7 1.2 2.7 2.7c0 1.5-1.2 2.7-2.7 2.7H2V20a2 2 0 0 0 2 2h3.8v-1.5c0-1.5 1.2-2.7 2.7-2.7c1.5 0 2.7 1.2 2.7 2.7V22H17a2 2 0 0 0 2-2v-4h1.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5Z"
  })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Developer's Games", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--mdi",
  width: "32",
  height: "32",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m19 22.3l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8c1.2 0 2.2.9 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6l-.6.5M20.5 11H19V7a2 2 0 0 0-2-2h-4V3.5a2.5 2.5 0 0 0-5 0V5H4c-1.1 0-2 .9-2 2v3.8h1.5c1.5 0 2.7 1.2 2.7 2.7S5 16.2 3.5 16.2H2V20a2 2 0 0 0 2 2h3.8v-1.5c0-1.5 1.2-2.7 2.7-2.7c.94 0 1.77.47 2.25 1.2h.34c-.05-.33-.09-.66-.09-1c0-3.31 2.69-6 6-6c1.54 0 2.94.58 4 1.53v-.03a2.5 2.5 0 0 0-2.5-2.5Z"
  })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add To Favourites", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--mdi",
  width: "32",
  height: "32",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m19 22.3l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8c1.2 0 2.2.9 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6l-.6.5M20.5 11H19V7a2 2 0 0 0-2-2h-4V3.5a2.5 2.5 0 0 0-5 0V5H4c-1.1 0-2 .9-2 2v3.8h1.5c1.5 0 2.7 1.2 2.7 2.7S5 16.2 3.5 16.2H2V20a2 2 0 0 0 2 2h3.8v-1.5c0-1.5 1.2-2.7 2.7-2.7c.94 0 1.77.47 2.25 1.2h.34c-.05-.33-.09-.66-.09-1c0-3.31 2.69-6 6-6c1.54 0 2.94.58 4 1.53v-.03a2.5 2.5 0 0 0-2.5-2.5Z"
  })
], -1))
const _hoisted_31 = { class: "" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--mdi",
  width: "32",
  height: "32",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m19 22.3l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8c1.2 0 2.2.9 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6l-.6.5M20.5 11H19V7a2 2 0 0 0-2-2h-4V3.5a2.5 2.5 0 0 0-5 0V5H4c-1.1 0-2 .9-2 2v3.8h1.5c1.5 0 2.7 1.2 2.7 2.7S5 16.2 3.5 16.2H2V20a2 2 0 0 0 2 2h3.8v-1.5c0-1.5 1.2-2.7 2.7-2.7c.94 0 1.77.47 2.25 1.2h.34c-.05-.33-.09-.66-.09-1c0-3.31 2.69-6 6-6c1.54 0 2.94.58 4 1.53v-.03a2.5 2.5 0 0 0-2.5-2.5Z"
  })
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add to Favourites", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m19 20.09l2.45 1.49l-.65-2.81l2.2-1.88l-2.89-.25L19 14l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49m4-6.59v.03A5.97 5.97 0 0 0 19 12c-3.31 0-6 2.69-6 6c0 .34.04.67.09 1h-.34a2.68 2.68 0 0 0-2.25-1.2c-1.5 0-2.7 1.2-2.7 2.7V22H4a2 2 0 0 1-2-2v-3.8h1.5c1.5 0 2.7-1.2 2.7-2.7S5 10.8 3.5 10.8H2V7c0-1.1.9-2 2-2h4V3.5a2.5 2.5 0 0 1 5 0V5h4a2 2 0 0 1 2 2v4h1.5a2.5 2.5 0 0 1 2.5 2.5Z"
  })
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rate this Game", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m19 20.09l2.45 1.49l-.65-2.81l2.2-1.88l-2.89-.25L19 14l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49m4-6.59v.03A5.97 5.97 0 0 0 19 12c-3.31 0-6 2.69-6 6c0 .34.04.67.09 1h-.34a2.68 2.68 0 0 0-2.25-1.2c-1.5 0-2.7 1.2-2.7 2.7V22H4a2 2 0 0 1-2-2v-3.8h1.5c1.5 0 2.7-1.2 2.7-2.7S5 10.8 3.5 10.8H2V7c0-1.1.9-2 2-2h4V3.5a2.5 2.5 0 0 1 5 0V5h4a2 2 0 0 1 2 2v4h1.5a2.5 2.5 0 0 1 2.5 2.5Z"
  })
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rate this Game", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center hover:bg-red-hover rounded-md space-x-3 bg-black-border border border-gray-400 py-3 px-5" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    class: "iconify iconify--mdi",
    width: "32",
    height: "32",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M13.04 19.61a2.682 2.682 0 0 0-2.54-1.81c-1.5 0-2.7 1.2-2.7 2.7V22H4a2 2 0 0 1-2-2v-3.8h1.5c1.5 0 2.7-1.2 2.7-2.7S5 10.8 3.5 10.8H2V7c0-1.1.9-2 2-2h4V3.5a2.5 2.5 0 0 1 5 0V5h4a2 2 0 0 1 2 2v4h1.5a2.5 2.5 0 0 1 2.5 2.5c0 .32-.06.62-.17.89A5.991 5.991 0 0 0 19 13c-3.31 0-6 2.69-6 6c0 .2 0 .41.04.61M18 15v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Related Games")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue3star_ratings = _resolveComponent("vue3star-ratings")!
  const _component_GamesFeedbackModal = _resolveComponent("GamesFeedbackModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_router_link, {
            to: { name: 'viewGamesDetails', params: { gameId: _ctx.gameId }},
            class: "game-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_5,
          _createElementVNode("span", {
            class: _normalizeClass([_ctx.label=='Testnet'?'xr-test-net':'xr-main-net', "mx-1"])
          }, _hoisted_10, 2),
          _createElementVNode("span", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.label) + " Environment. ", 1),
            _createElementVNode("button", {
              class: "bg-gray-600 hover:bg-red-primary text-white text-sm px-2 py-1 rounded-md font-semibold transition-all duration-200",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.displayFeedbackModal = true;})
            }, "Feedback")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.headerImage != 'none')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "flex cover-img w-full h-full blur-md opacity-50",
                style: _normalizeStyle('background-image: url(' + _ctx.headerImage + '); background-repeat: no-repeat;')
              }, null, 4))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("img", {
                  src: require(`@/assets/images/default-cover.png`)
                }, null, 8, _hoisted_15)
              ])),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.headerImage != 'none')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "card-img rounded-sm w-full h-full",
                  style: _normalizeStyle('background-image: url(' + _ctx.headerImage + '); background-repeat: no-repeat;' )
                }, null, 4))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: { name: 'viewGamesPlay', params: { gameId: _ctx.gameId } },
              class: "btn-primary-full rounded-sm"
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_20, [
            (_ctx.avgRating >= 0)
              ? (_openBlock(), _createBlock(_component_vue3star_ratings, {
                  key: 0,
                  modelValue: _ctx.avgRating,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.avgRating) = $event)),
                  showControl: false,
                  disableClick: true,
                  starSize: '15'
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.avgRating)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.totalRatings) + " Ratings", 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.about)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "text-gray-text truncate",
                style: {"margin-bottom":"10px"},
                innerHTML: _ctx.about.replace(/<\/?[^>]+>/ig, '').substring(0, 100)
              }, null, 8, _hoisted_22))
            : _createCommentVNode("", true),
          _hoisted_23,
          _createVNode(_component_router_link, {
            to: { name: 'viewGamesDetails', params: { gameId: _ctx.gameId } },
            class: "btn-more-detail border border-black-border w-full my-8"
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_25, [
            (_ctx.submittedById)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {name: 'viewDeveloperProfile', params: {developerId: _ctx.submittedById}},
                  class: "flex items-center hover:bg-red-hover rounded-sm space-x-3 bg-black-border border border-gray-400 py-3 px-5"
                }, {
                  default: _withCtx(() => [
                    _hoisted_26,
                    _hoisted_27
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (!_ctx.store.getters['auth/authenticated'])
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: { name: 'viewAuthLogin' },
                  class: "flex items-center hover:bg-red-hover rounded-md space-x-3 bg-black-border border border-gray-400 py-3 px-5"
                }, {
                  default: _withCtx(() => [
                    _hoisted_28,
                    _hoisted_29
                  ]),
                  _: 1
                }))
              : (_ctx.favourited)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unfavouriteGame && _ctx.unfavouriteGame(...args))),
                    onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.favouritestext = 'Unfavourite')),
                    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.favouritestext = 'Added to Favourites')),
                    class: "group flex items-center hover:bg-red-hover rounded-md space-x-3 bg-black-border border border-gray-400 py-3 px-5"
                  }, [
                    _hoisted_30,
                    _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.favouritestext), 1)
                  ], 32))
                : (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.favouriteGame && _ctx.favouriteGame(...args))),
                    class: "flex items-center hover:bg-red-hover rounded-md space-x-3 bg-black-border border border-gray-400 py-3 px-5"
                  }, _hoisted_34)),
            (!_ctx.store.getters['auth/authenticated'])
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: { name: 'viewAuthLogin' },
                  class: "flex items-center hover:bg-red-hover rounded-md space-x-3 bg-black-border border border-gray-400 py-3 px-5"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35,
                    _hoisted_36
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("button", {
                  key: 5,
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.displayFeedbackModal = true), ["prevent"])),
                  class: "flex items-center hover:bg-red-hover rounded-md space-x-3 bg-black-border border border-gray-400 py-3 px-5"
                }, _hoisted_39)),
            _createVNode(_component_router_link, {
              to: { name: 'viewGamesGenre', params: { category: _ctx.gameCategory } }
            }, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]),
      _createVNode(_component_GamesFeedbackModal, {
        gameId: _ctx.gameId,
        title: _ctx.title,
        displayFeedbackModal: _ctx.displayFeedbackModal,
        onCloseFeedbackModal: _cache[7] || (_cache[7] = ($event: any) => (_ctx.displayFeedbackModal = false, _ctx.fetchRatings()))
      }, null, 8, ["gameId", "title", "displayFeedbackModal"])
    ])
  ]))
}